/**
 * Shared layout option maps for reusable content blocks (BlockRichText, …).
 * Values are utility class names — bagelink utilities (`w1100px`, `w-100p`) plus
 * the project-local `.pageHeight` from `src/styles/main.css`.
 *
 * Mirrors the pattern used by sibling projects (e.g. sellameir's blockLayout).
 */
import { $ } from '@bagelink/vue'

/**
 * CMS checkbox — apply the site's `.pageHeight` min-height (full page height
 * under the nav). Spread into `defineSchema({ ...pageHeightField(), … })`.
 */
export function pageHeightField(defaultOn = false) {
	return {
		pageHeight: $.checkbox('Full page height', { default: defaultOn }),
	}
}

/** Class string for the block root when `pageHeight` is on. */
export function pageHeightClass(enabled?: boolean) {
	return enabled ? 'pageHeight' : ''
}

/** Max-width options for a content box (label → value). */
export const CONTENT_WIDTH_OPTIONS = [
	{ label: '720px', value: '720' },
	{ label: '900px', value: '900' },
	{ label: '1000px', value: '1000' },
	{ label: '1100px', value: '1100' },
	{ label: '1200px', value: '1200' },
	{ label: 'Full', value: 'full' },
] as const

const WIDTH_CLASS: Record<string, string> = {
	'720': 'w720px',
	'900': 'w900px',
	'1000': 'w1000px',
	'1100': 'w1100px',
	'1200': 'w1200px',
	full: 'w-100p',
}

/** Resolve a width option value → the matching max-width utility class. */
export function widthClass(width?: string, fallback = '720') {
	return WIDTH_CLASS[width || fallback] || WIDTH_CLASS[fallback]
}
